export default __webpack_public_path__ + "images/loggedout/icons/teacher_signup-3f59ab632f5ffc604a1253e795c844df.png";